module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-tab-section"
  }, [(_vm.props.title) ? _c('Title', {
    attrs: {
      "props": _vm.props
    }
  }) : _vm._e(), (!_vm.$route.path.includes("technology") && !_vm.$route.path.includes("services")) ? _c('div', {
    staticClass: "block-tab-section__container"
  }, [_c('div', {
    staticClass: "block-tab-section__tabs"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: "block-tab-section__tab",
      class: {
        active: i === _vm.active
      },
      on: {
        "click": function($event) {
          _vm.setIndex(i)
        }
      }
    }, [_c('div', {
      staticClass: "block-tab-section__tab--text",
      domProps: {
        "innerHTML": _vm._s(tab.label)
      }
    }), _c('div', {
      staticClass: "block-tab-section__tab--subcontainer"
    }, [(tab.image) ? _c('div', {
      staticClass: "block-tab-section__tab--image",
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      })
    }) : _vm._e()])])
  })), _vm._l((_vm.props.content), function(content, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.active),
        expression: "i === active"
      }],
      key: i,
      staticClass: "block-tab-section__content-container"
    }, [_c('div', {
      staticClass: "block-tab-section__content",
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), (content.img) ? _c('div', {
      staticClass: "block-tab-section__img"
    }, [_c('img', {
      attrs: {
        "src": content.img
      }
    })]) : _vm._e()])
  })], 2) : _vm._e(), (_vm.$route.path.includes("technology")) ? _c('div', {
    staticClass: "block-tab-section__container"
  }, [_c('div', {
    staticClass: "block-tab-section__tabs"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: "block-tab-section__tab",
      class: {
        active: i === _vm.$store.state.body
      },
      on: {
        "click": function($event) {
          _vm.setTechIndex(i)
        }
      }
    }, [_c('div', {
      staticClass: "block-tab-section__tab--text",
      domProps: {
        "innerHTML": _vm._s(tab.label)
      }
    }), _c('div', {
      staticClass: "block-tab-section__tab--subcontainer"
    }, [(tab.image) ? _c('div', {
      staticClass: "block-tab-section__tab--image",
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      })
    }) : _vm._e()])])
  })), _vm._l((_vm.props.content), function(content, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.$store.state.body),
        expression: "i === $store.state.body"
      }],
      key: i,
      staticClass: "block-tab-section__content-container"
    }, [_c('div', {
      staticClass: "block-tab-section__content",
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), (content.img) ? _c('div', {
      staticClass: "block-tab-section__img"
    }, [_c('img', {
      attrs: {
        "src": content.img
      }
    })]) : _vm._e()])
  })], 2) : _vm._e(), (_vm.$route.path.includes("services")) ? _c('div', {
    staticClass: "block-tab-section__container"
  }, [_c('div', {
    staticClass: "block-tab-section__tabs"
  }, _vm._l((_vm.props.tabs), function(tab, i) {
    return _c('div', {
      key: i,
      staticClass: "block-tab-section__tab",
      class: {
        active: i === _vm.$store.state.body
      },
      on: {
        "click": function($event) {
          _vm.setTechIndex(i)
        }
      }
    }, [_c('div', {
      staticClass: "block-tab-section__tab--text",
      domProps: {
        "innerHTML": _vm._s(tab.label)
      }
    }), _c('div', {
      staticClass: "block-tab-section__tab--subcontainer"
    }, [(tab.image) ? _c('div', {
      staticClass: "block-tab-section__tab--image",
      style: ({
        backgroundImage: 'url(' + tab.image + ')'
      })
    }) : _vm._e()])])
  })), _vm._l((_vm.props.content), function(content, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i === _vm.$store.state.body),
        expression: "i === $store.state.body"
      }],
      key: i,
      staticClass: "block-tab-section__content-container"
    }, [_c('div', {
      staticClass: "block-tab-section__content",
      domProps: {
        "innerHTML": _vm._s(content.text)
      }
    }), (content.img) ? _c('div', {
      staticClass: "block-tab-section__img"
    }, [_c('img', {
      attrs: {
        "src": content.img
      }
    })]) : _vm._e()])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16f16f3e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-tab-section/block-tab-section.pug
// module id = 1106
// module chunks = 1